import React from "react"
import { Link } from "gatsby"
import Contact from "../components/Contact/Contact"
import Layout from "../components/Layout/Layout"
import SEO from "../components/Seo"

const ContactPage = () => (
  <Layout>
    <SEO title="Contact" />
    <Contact />
  </Layout>
)

export default ContactPage
